/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PasscodeSmsAuthMethodViewModel } from './passcodeSmsAuthMethodViewModel';
import { SoftTokenAuthMethodViewModel } from './softTokenAuthMethodViewModel';
import { YubikeyAuthMethodViewModel } from './yubikeyAuthMethodViewModel';
import { StaticCodeAuthMethodViewModel } from './staticCodeAuthMethodViewModel';
import { AuthMethodType } from './authMethodType';
import { CredentialViewModel } from './credentialViewModel';
import { AttestationModel } from './attestationModel';
import { HardwareTokenAuthMethodViewModel } from './hardwareTokenAuthMethodViewModel';
import { PasscodeEmailAuthMethodViewModel } from './passcodeEmailAuthMethodViewModel';
import { BackupViewModel } from './backupViewModel';
import { FidoAuthMethodViewModel } from './fidoAuthMethodViewModel';
import { PasswordAuthMethodViewModel } from './passwordAuthMethodViewModel';


/**
 * @type ApiAuthMethodsGet200ResponseInner
 * @export
 */
export type ApiAuthMethodsGet200ResponseInner = FidoAuthMethodViewModel | HardwareTokenAuthMethodViewModel | PasscodeEmailAuthMethodViewModel | PasscodeSmsAuthMethodViewModel | PasswordAuthMethodViewModel | SoftTokenAuthMethodViewModel | StaticCodeAuthMethodViewModel | YubikeyAuthMethodViewModel;

